/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache, useQuery } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { getQueryKey } from '../getQueryKey';
import { executeUserStorageDataFlow } from '../operations/executeUserStorageDataFlow';
// NOTE: There appears to be a bug in this implementation where the setQueryData using network
// data is performed before useQuery initially sets the cache using persisted data.
// This may have something to do with the secondary caching layer within getUserStorageItem.ts
// or the fact that data is available immediately in the DOM.
export function usePersistedUserStorage(storageKey, forceRefresh, remoteAttempts) {
    var context = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var queryKey = getQueryKey(storageKey);
    return useQuery(queryKey, function () {
        return executeUserStorageDataFlow(storageKey, identity, context, function (freshData) { return queryCache.setQueryData(queryKey, freshData); }, forceRefresh, remoteAttempts);
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: context && identity && !!storageKey,
    });
}
//# sourceMappingURL=usePersistedUserStorage.js.map